import { toast } from 'react-toastify';

import { getSerializedErrorMessage } from '../../../../../utils/errors';
import { decrementPendingReferralInfoUpdates } from './utils';

import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import type { IOnboardingQuestionnaireReferralInfo } from '../../../../../pages/questionnaires/onboarding/components/forms/referral/types';
import type { OnboardingQuestionnaireState } from '../../types';
import type { OnboardingReferralThunks } from './types';

export function addOnboardingReferralCases(
  builder: ActionReducerMapBuilder<OnboardingQuestionnaireState>,
  thunks: OnboardingReferralThunks,
) {
  addUpdateOnboardingQuestionnaireReferralInfoCases(builder, thunks);
}

function addUpdateOnboardingQuestionnaireReferralInfoCases(
  builder: ActionReducerMapBuilder<OnboardingQuestionnaireState>,
  thunks: OnboardingReferralThunks,
) {
  const { updateOnboardingQuestionnaireReferralInfo } = thunks;

  builder
    .addCase(
      updateOnboardingQuestionnaireReferralInfo.pending,
      (state: OnboardingQuestionnaireState) => {
        state.pendingReferralInfoUpdateCount += 1;
        state.updateReferralInfoLoading = true;
        state.error = null;
      },
    )
    .addCase(
      updateOnboardingQuestionnaireReferralInfo.fulfilled,
      (
        state: OnboardingQuestionnaireState,
        action: PayloadAction<IOnboardingQuestionnaireReferralInfo>,
      ) => {
        decrementPendingReferralInfoUpdates(state);
        if (state.onboardingQuestionnaireDetails) {
          state.onboardingQuestionnaireDetails.referral = action.payload;
        }
      },
    )
    .addCase(
      updateOnboardingQuestionnaireReferralInfo.rejected,
      (state: OnboardingQuestionnaireState, action) => {
        state.error = action.error;
        decrementPendingReferralInfoUpdates(state);
        toast.error(getSerializedErrorMessage(action.error));
      },
    );
}
